import React from "react";
import { mockedHeroBannerPromoWidgetData } from "../../mock/heroBannerData";
import { productCardsListData } from "../../mock/productCardData";
import { carouselData } from "../../mock/carouselItems";
import { brands } from "../../mock/brandWallItems";
import { newsLetterContent } from "../../mock/newsLetter";
import { articleWidgetCarouselData } from "../../mock/articleWidgetData";
import { promoDataNoBrandNoDescriptionCarousel } from "../../mock/promoData";

import { NewsLetter } from "../NewsLetter";

import {
  HeroBanner,
  ProductCard,
  Categories,
  BrandWall,
  PromoWidget,
  Carousel,
  Typography,
  Row,
  Column,
  ArticleWidget,
  Link,
} from "../../components";

import { Footer } from "../Footer";
import { DesktopMenu } from "../Menu";

function LandingPage() {
  return (
    <>
      <DesktopMenu />
      <div className="container-fluid flex-grow-1 position-relative mb-10">
        <HeroBanner
          banners={mockedHeroBannerPromoWidgetData}
          delay={1000}
          classes={{ root: "mt-10" }}
        />
        <Typography as="h2" variant="h2-enriched" classes={{ root: "mt-10" }}>
          Recommendation
        </Typography>
        <Carousel variant="products-carousel">
          {productCardsListData.map((product) => (
            <ProductCard
              key={product.description.product.text as string}
              productCardData={product}
            />
          ))}
        </Carousel>
        <Typography as="h2" variant="h2-enriched" classes={{ root: "mt-10" }}>
          Shop By Category
        </Typography>
        <Categories carouselItems={carouselData.carouselItems} />
        <Typography as="h2" variant="h2-enriched" classes={{ root: "mt-10" }}>
          Fresh Drops
        </Typography>
        <Carousel variant="products-carousel">
          {promoDataNoBrandNoDescriptionCarousel.map((article) => (
            <PromoWidget
              key={article.id}
              {...article}
              size="medium"
              type="primary"
            />
          ))}
        </Carousel>
        <Typography as="h2" variant="h2-enriched" classes={{ root: "mt-10" }}>
          Best Sellers
        </Typography>
        <PromoWidget
          actions={[
            {
              id: "1",
              link: {
                href: "/promo/1/men",
              },
              text: "shop men",
            },
          ]}
          description="Discover gear from the National Team"
          iconMediaData={{
            data: {
              icon: "NikeIcon",
            },
            type: "svg-icon",
          }}
          id="1"
          link={{
            href: "/promo/1",
          }}
          mediaData={{
            data: {
              alt: "",
              src: "assets/images/widget/promo-banner.png",
            },
            type: "image",
          }}
          size="wide"
          title="Top 10 training shoes for outdoor in the summer"
          type="primary"
        />
        <div className="mt-10 d-flex align-items-center">
          <Typography as="h2" variant="h2-enriched" classes={{ root: "me-4" }}>
            Brands You Love
          </Typography>
          <Link href="/">View All</Link>
        </div>
        <BrandWall items={brands} />
        <Typography as="h2" variant="h2-enriched" classes={{ root: "mt-10" }}>
          Lastest Stories
        </Typography>
        <Carousel variant="products-carousel">
          {articleWidgetCarouselData.map((article) => (
            <ArticleWidget
              key={article.id}
              {...article}
              size="medium"
              type="default"
            />
          ))}
        </Carousel>
        <div className="mt-10" />
        <div className="bg-color-grey-100">
          <div
            className="seo-content d-flex flex-wrap mx-auto justify-content-center py-6 py-lg-9 px-ms-7 px-4"
            style={{ maxWidth: 1048 }}
          >
            <Row>
              <Column xs={12}>
                <Typography
                  as="h4"
                  variant="h-menu"
                  classes={{ root: "mt-4 mb-8" }}
                >
                  Intersport Austria - For The Love Of Sport
                </Typography>
              </Column>
              <Column xs={6}>
                <Typography
                  as="p"
                  variant="text-bold-header"
                  classes={{ root: "mb-8" }}
                >
                  We Are Your No.1 Sports Retail
                </Typography>
                <Typography as="p" variant="text-regular">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                  Sequi exercitationem quidem, assumenda consequatur ratione
                  molestiae, debitis repellendus incidunt accusantium laboriosam
                  tempora sed nesciunt, voluptas vel ut. Et itaque mollitia
                  explicabo! Lorem ipsum dolor sit amet consectetur adipisicing
                  elit. Et dolor ipsam eos mollitia quisquam id, quibusdam
                  tenetur praesentium ad, atque ea nam eligendi odit laboriosam
                  earum ullam omnis? Laboriosam, minima.
                </Typography>
              </Column>
              <Column xs={6}>
                <Typography
                  as="p"
                  variant="text-bold-header"
                  classes={{ root: "mb-8" }}
                >
                  We Are Your No.1 Sports Retail
                </Typography>
                <Typography as="p" variant="text-regular">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                  Sequi exercitationem quidem, assumenda consequatur ratione
                  molestiae, debitis repellendus incidunt accusantium laboriosam
                  tempora sed nesciunt, voluptas vel ut. Et itaque mollitia
                  explicabo!
                </Typography>
              </Column>
            </Row>
          </div>
        </div>
        <div className="mt-10" />
        <NewsLetter {...newsLetterContent} />
      </div>

      <div className="container-fluid">
        <Footer />
      </div>
    </>
  );
}

export default LandingPage;
